<template>
  <div>
    <!-- 打标 -->
    <div v-show="false">
      <div class="labeling" ref="labeling">
        <p>{{ labelData.order_sn }}</p>
        <p>NO:{{ labelData.sorting }}</p>
        <p>Made in China</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      labelData: {
        sorting: '',
        order_sn: '',
      },
    }
  },
  methods: {
    // 打标
    labeling() {
      this.$nextTick(() => {
        this.$print(this.$refs.labeling);
      });
    }
  },
}
</script>
<style scoped>
.labeling {
  padding: 30px;

  p {
    font-size: 48px;
    margin-bottom: 25px;
    text-align: center;
    color: #000;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
</style>
